// SweetAlert2
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"

export function freightAlert(title: string): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    withReactContent(Swal).fire({
      title: "Are you sure want to continue?",
      text: `This ${title} still has no freight cost`,
      showCancelButton: true,
      confirmButtonText: "Save",
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-error"
      }
    }).then(res => {
      if (res.isConfirmed) {
        resolve()
      } else {
        reject()
      }
    })
  })
}